import store from '../../store';

export function resetPage() {
    store.dispatch('resetPagination');
    clearAllSelected();
}

export function clearAllSelected() {
    store.dispatch('resetSorting');
    store.dispatch('resetSearch');
    store.dispatch('resetFilter');
    store.dispatch('resetSelectedItems');
}


// WEBPACK FOOTER //
// ./src/store/modules/page/reset.js